import React from "react";
import { GlassCard, Button } from "../components/ui";
import { btn3d } from "../styles/buttonStyles";

export default function MyTripPage({ dm, loggedInUser, personal, savedTrips, savedTripsLoaded, savedTripsError, loadSavedTrips, setAuthMode, setStep, darkMode, DAY_ACCENT, loadSavedTripToResult, deleteSavedTrip }) {
  return (
            <div className="animate-in">
              <GlassCard>
                {/* 헤더 */}
                <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:20 }}>
                  <div className="text-xl" style={{ width:48, height:48, borderRadius:14, background:"rgba(129,140,248,0.12)", border:"1.5px solid rgba(129,140,248,0.25)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>🗺️</div>
                  <div style={{ flex:1 }}>
                    <h2 className="text-md" style={{ fontWeight:800, color:"var(--accent)" }}>내 여행 기록</h2>
                    <p className="text-xs" style={{ color:dm?"rgba(226,232,240,0.70)":"rgba(51,65,85,0.65)" }}>{loggedInUser ? `${personal.name||loggedInUser}님이 만든 모든 여행` : "로그인 후 내 여행을 확인하세요"}</p>
                  </div>
                  {loggedInUser && savedTrips.length > 0 && (
                    <div className="text-xs" style={{ flexShrink:0, padding:"4px 12px", borderRadius:100, background:"var(--accent)", color:"#fff", fontWeight:800 }}>{savedTrips.length}개</div>
                  )}
                </div>

                {loggedInUser && savedTripsError && (
                  <div role="alert" style={{ marginBottom:14, padding:"12px 14px", borderRadius:12, textAlign:"center", background:dm?"rgba(255,90,80,0.10)":"rgba(255,230,227,0.75)", border:"1px solid rgba(200,60,45,0.3)" }}>
                    <p className="text-sm" style={{ color:dm?"#FF8F80":"#C0392B", fontWeight:800, marginBottom:10 }}>⚠️ {savedTripsError}</p>
                    <button onClick={loadSavedTrips} className="btn3d text-sm" style={{ ...btn3d("danger", dm), padding:"9px 16px", minHeight:40, borderRadius:11, fontWeight:800 }}>
                      다시 불러오기
                    </button>
                  </div>
                )}

                {!loggedInUser ? (
                  <div style={{ textAlign:"center", padding:"40px 20px" }}>
                    <div style={{ fontSize: 'clamp(2rem, 1.3rem + 1.2vw, 2.8rem)', marginBottom: 12 }}>🔒</div>
                    <p className="text-base" style={{ fontWeight:700, color:"var(--text)", marginBottom:6 }}>로그인이 필요해요</p>
                    <p className="text-sm" style={{ color:dm?"rgba(226,232,240,0.65)":"rgba(51,65,85,0.60)", marginBottom:16 }}>내 여행 기록을 보려면 로그인해주세요</p>
                    <Button darkMode={darkMode} small onClick={()=>{ setAuthMode("login"); setStep("login"); }}>🔑 로그인하기</Button>
                  </div>
                ) : !savedTripsLoaded ? (
                  <div style={{ textAlign:"center", padding:"40px 20px", color:"var(--accent)", fontWeight:700 }}>
                    저장된 여행을 불러오는 중...
                  </div>
                ) : savedTripsError && savedTrips.length === 0 ? null
                : savedTrips.length === 0 ? (
                  <div style={{ textAlign:"center", padding:"40px 20px" }}>
                    <div style={{ fontSize: 'clamp(2rem, 1.3rem + 1.2vw, 2.8rem)', marginBottom: 12 }}>✈️</div>
                    <p className="text-base" style={{ fontWeight:700, color:"var(--text)", marginBottom:6 }}>아직 저장된 여행이 없어요</p>
                    <p className="text-sm" style={{ color:dm?"rgba(226,232,240,0.65)":"rgba(51,65,85,0.60)", marginBottom:16 }}>여행 일정을 생성하면 자동으로 저장돼요!</p>
                    <Button darkMode={darkMode} small onClick={()=>setStep("travel")}>✨ 여행 만들기</Button>
                  </div>
                ) : (
                  <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                    {/* 통계 요약 바 */}
                    <div style={{ display:"flex", gap:10, padding:"12px 14px", borderRadius:13, background:dm?"rgba(129,140,248,0.07)":"rgba(238,242,255,0.8)", border:dm?"1px solid rgba(129,140,248,0.15)":"1px solid rgba(99,102,241,0.2)" }}>
                      {[
                        { icon:"✈️", label:"총 여행", val:`${savedTrips.length}회` },
                        { icon:"🌏", label:"방문 도시", val:`${[...new Set(savedTrips.map(t=>t.destination).filter(Boolean))].length}곳` },
                        { icon:"📅", label:"최근 여행", val: savedTrips[0]?.destination || "-" },
                      ].map((s,i)=>(
                        <div key={i} style={{ flex:1, textAlign:"center" }}>
                          <div className="text-base" style={{ marginBottom:2 }}>{s.icon}</div>
                          <div className="text-sm" style={{ fontWeight:900, color:"var(--accent)" }}>{s.val}</div>
                          <div className="text-xs" style={{ color:dm?"rgba(226,232,240,0.60)":"rgba(51,65,85,0.55)" }}>{s.label}</div>
                        </div>
                      ))}
                    </div>

                    {/* 여행 기록 목록 */}
                    {savedTrips.map((trip, idx) => {
                      // 일정에서 날짜별 장소 추출
                      const lines = (trip.itinerary || "").split('\n');
                      const dayLogs = [];
                      let curDay = null;
                      lines.forEach(line => {
                        const t = line.trim();
                        if (!t) return;
                        if (t.startsWith('📅')) {
                          curDay = { day: t.replace(/^📅\s*/, ''), places: [] };
                          dayLogs.push(curDay);
                        } else if (curDay && (t.startsWith('🌅') || t.startsWith('🌞') || t.startsWith('🌙') || t.startsWith('•') || t.startsWith('-'))) {
                          const place = t.replace(/^[🌅🌞🌙•\-]+\s*/, '').split(/[:\-–]/)[0].trim();
                          if (place && place.length > 0 && place.length < 25) curDay.places.push(place);
                        }
                      });
                      const nights = trip.startDate && trip.endDate
                        ? Math.max(0, (new Date(trip.endDate) - new Date(trip.startDate)) / 86400000)
                        : 0;
                      return (
                        <div key={idx} style={{ borderRadius:16, border:`1.5px solid ${dm?"rgba(129,140,248,0.18)":"rgba(99,102,241,0.20)"}`, background:dm?"rgba(255,255,255,0.04)":"rgba(255,255,255,0.88)", overflow:"hidden" }}>
                          <div style={{ height:3, background:`linear-gradient(90deg,${DAY_ACCENT[idx % DAY_ACCENT.length]},${DAY_ACCENT[(idx+2) % DAY_ACCENT.length]})` }}/>
                          <div style={{ padding:"14px 16px" }}>
                            {/* 목적지 + 저장일 */}
                            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
                              <span className="text-base" style={{ fontWeight:900, color:"var(--accent)" }}>✈️ {trip.destination}</span>
                              <span className="text-xs" style={{ color:dm?"rgba(226,232,240,0.42)":"rgba(51,65,85,0.38)" }}>
                                {trip.savedAt ? new Date(trip.savedAt).toLocaleDateString("ko-KR") : ""}
                              </span>
                            </div>
                            {/* 날짜 + 기간 */}
                            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10 }}>
                              <span className="text-xs" style={{ padding:"3px 10px", borderRadius:100, background:dm?"rgba(129,140,248,0.10)":"rgba(238,242,255,0.95)", border:`1px solid ${dm?"rgba(129,140,248,0.20)":"rgba(99,102,241,0.22)"}`, color:"var(--accent)", fontWeight:700 }}>
                                📅 {trip.startDate} ~ {trip.endDate}
                              </span>
                              <span className="text-xs" style={{ color:dm?"rgba(226,232,240,0.60)":"rgba(71,85,105,0.60)", fontWeight:600 }}>
                                {nights === 0 ? "당일" : `${nights}박 ${nights+1}일`}
                              </span>
                            </div>
                            {/* 이동 동선 타임라인 */}
                            {dayLogs.length > 0 ? (
                              <div style={{ padding:"10px 12px", borderRadius:10, background:dm?"rgba(255,255,255,0.04)":"rgba(248,250,252,0.9)", border:dm?"1px solid rgba(129,140,248,0.10)":"1px solid rgba(99,102,241,0.12)", marginBottom:12 }}>
                                <div className="text-xs" style={{ fontWeight:800, color:dm?"rgba(226,232,240,0.45)":"rgba(67,56,202,0.50)", letterSpacing:"0.06em", marginBottom:7 }}>이동 동선</div>
                                <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
                                  {dayLogs.map((d, di) => (
                                    <div key={di} style={{ display:"flex", alignItems:"flex-start", gap:8 }}>
                                      <div style={{ display:"flex", flexDirection:"column", alignItems:"center", flexShrink:0, marginTop:2 }}>
                                        <div style={{ width:7, height:7, borderRadius:"50%", background:DAY_ACCENT[di % DAY_ACCENT.length] }}/>
                                        {di < dayLogs.length-1 && <div style={{ width:1.5, height:14, background:dm?"rgba(129,140,248,0.15)":"rgba(99,102,241,0.20)", marginTop:2 }}/>}
                                      </div>
                                      <div style={{ flex:1, paddingBottom: di < dayLogs.length-1 ? 2 : 0 }}>
                                        <span className="text-xs" style={{ fontWeight:800, color:DAY_ACCENT[di % DAY_ACCENT.length], marginRight:6 }}>{d.day}</span>
                                        {d.places.length > 0
                                          ? <span className="text-xs" style={{ color:dm?"rgba(226,232,240,0.75)":"rgba(51,65,85,0.75)" }}>{d.places.join(' → ')}</span>
                                          : <span className="text-xs" style={{ color:dm?"rgba(226,232,240,0.32)":"rgba(51,65,85,0.32)" }}>기록 없음</span>
                                        }
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ) : (
                              <div className="text-xs" style={{ color:dm?"rgba(226,232,240,0.40)":"rgba(71,85,105,0.40)", marginBottom:12 }}>일정 데이터 없음</div>
                            )}
                            {/* 버튼 */}
                            <div style={{ display:"flex", gap:7 }}>
                              <button onClick={() => loadSavedTripToResult(trip)}
                                className="btn3d text-sm" style={{ ...btn3d("primary", dm), flex:1, padding:"11px 12px", minHeight:44, borderRadius:12, fontWeight:800 }}>
                                📋 전체 일정 보기
                              </button>
                              <button onClick={() => deleteSavedTrip(idx)}
                                className="btn3d text-sm" style={{ ...btn3d("danger", dm), padding:"11px 14px", minHeight:44, borderRadius:12, fontWeight:800 }}>
                                🗑️
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </GlassCard>
            </div>
  );
}
